import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import swiftixLogo from '@/assets/swiftix-logo.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Path to link to. Pass `null` to render as a plain div (no anchor). Defaults to "/". */
  linkTo?: string | null;
}

export const Logo = ({ size = 'md', className = '', linkTo = '/' }: LogoProps) => {
  const imgSizes = {
    sm: 'h-7',
    md: 'h-9',
    lg: 'h-11'
  };

  const textSizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl'
  };

  const inner = (
    <>
      <motion.img
        src={swiftixLogo}
        alt="Swiftix"
        className={`${imgSizes[size]} w-auto`}
        style={{
          filter: 'drop-shadow(0 0 10px hsl(var(--primary) / 0.6)) drop-shadow(0 0 20px hsl(var(--accent) / 0.4))',
        }}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      />
      <motion.span
        className={`${textSizes[size]} font-bold bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent bg-[length:300%_100%]`}
        style={{
          filter: 'drop-shadow(0 0 16px hsl(var(--primary) / 0.7)) drop-shadow(0 0 32px hsl(var(--accent) / 0.5))',
          animation: 'logo-gradient 4s ease-in-out infinite'
        }}
        whileHover={{ scale: 1.03 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        Swiftix
      </motion.span>
    </>
  );

  const sharedClass = `flex items-center gap-2 group ${className}`;

  if (linkTo === null) {
    return <div className={sharedClass}>{inner}</div>;
  }

  return (
    <Link to={linkTo} className={sharedClass}>
      {inner}
    </Link>
  );
};
